import React, { useState } from 'react';
import { User } from '../types';
import { Button } from './Button';
import { config } from '../services/config';

interface DevLoginProps {
  onLogin: (user: User) => void;
}

export const DevLogin: React.FC<DevLoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('globalinteldata@gmail.com');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const testUsers = [
    { email: 'globalinteldata@gmail.com', name: 'Intel data', projects: 3 },
    { email: 'pankajdev73@gmail.com', name: 'Pankaj Dev', projects: 1 }
  ];

  const handleDevLogin = async () => {
    setIsLoading(true);
    setError('');

    try {
      const apiBase = config.apiBaseUrl.replace(/\/$/, '');
      const response = await fetch(`${apiBase}/auth/dev-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Login failed');
      }

      const data = await response.json();
      onLogin(data.user);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl border border-slate-200">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl mb-4">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Development Login</h1>
          <p className="text-sm text-slate-500 mt-2">Bypass OAuth for local testing</p>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Select Test User
          </label>
          <select
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            {testUsers.map((user) => (
              <option key={user.email} value={user.email}>
                {user.name} - {user.projects} project{user.projects !== 1 ? 's' : ''}
              </option>
            ))}
          </select>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        <Button
          onClick={handleDevLogin}
          disabled={isLoading}
          className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white py-3"
        >
          {isLoading ? 'Logging in...' : 'Login as Test User'}
        </Button>

        <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <div className="flex items-start gap-2">
            <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div>
              <p className="text-xs font-semibold text-amber-800">Development Only</p>
              <p className="text-xs text-amber-700 mt-1">
                This login method is only available in development mode and will be disabled in production.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-4 text-center">
          <button
            onClick={() => window.location.hash = '#/admin-login'}
            className="text-sm text-indigo-600 hover:text-indigo-700 underline"
          >
            Admin Portal Login
          </button>
        </div>
      </div>
    </div>
  );
};
